import { createFileRoute } from '@tanstack/react-router'
import { SuratTemplateManager } from '../../../../components/SuratTemplateManager'
import { TemplateEditorPage } from '../../../../components/surat-template/editor/TemplateEditorPage'
import { useListScrollRestore } from '../../../../hooks/useListScrollRestore'

// K-2: editor dipilih lewat search param `?edit=`, BUKAN sub-route `template-surat/$id`.
// Alasannya bukan selera: DashboardLayout.tsx:44-45 menghitung activeTab dari SELURUH sisa
// path tanpa memotong di segmen pertama, lalu StaffShell/index.tsx:233 membandingkannya
// sama-dengan-persis. Sub-route membuat activeTab jadi 'template-surat/<id>' → sorotan
// sidebar mati dan onTabChange salah arah. Search param tidak mengubah pathname (R10).
export const Route = createFileRoute('/desa/$slug/dashboard/template-surat')({
  component: TemplateSuratRoute,
  validateSearch: (search: Record<string, unknown>): { edit?: string } => ({
    edit: typeof search.edit === 'string' ? search.edit : undefined,
  }),
})

function TemplateSuratRoute() {
  // `as any`: konteks route dashboard desa belum bertipe (pola yang sama dipakai sebelum F2).
  const { desaId } = Route.useRouteContext() as any
  const { edit } = Route.useSearch()
  const navigate = Route.useNavigate()
  // R11: komponen route ini tetap ter-mount saat anaknya berganti daftar <-> editor, jadi
  // di sinilah posisi gulir daftar bisa dititipkan agar selamat sampai petugas kembali.
  useListScrollRestore(!edit)

  if (!desaId) return null
  if (!edit) return <SuratTemplateManager desaId={desaId} />

  return (
    <TemplateEditorPage
      // R1: remount saat pindah ?edit=A → ?edit=B, agar state form template lama tidak bocor.
      key={edit}
      desaId={desaId}
      editId={edit}
      onBack={() => navigate({ search: { edit: undefined } })}
    />
  )
}
